// extracted by mini-css-extract-plugin
export default {"container":"exterior_container__J-C1Z","text":"exterior_text__AaOg3","info":"exterior_info__urieh"};